import type { ReactNode } from 'react';

import { ChartError } from '../../next/CustomDash/components/Chart/ChartError';
import { DataProviderQueryStatus } from '../../next/CustomDash/components/DataProvider/types';
import { useTabContentConfig } from '../../next/CustomDash/components/PageConfigProvider/PageConfigProvider';
import { useFilterContext } from '../../next/CustomDash/filters/contexts/FilterProvider';
import { UserPreferencesDataProvider } from './UserPreferencesDataProvider';
import { UserPreferencesContext } from './userPreferenceContext';
import { filtersToPreferences } from './utils/preference-filter-adapters';
import { getPreferenceScope } from './utils/preferences';

export function CustomDashPreferenceProivder({
  children,
}: {
  children: ReactNode;
}) {
  const { filterState, activeFilterMap } = useFilterContext();
  const { revelioPageId } = useTabContentConfig();
  const affectedScope = getPreferenceScope({
    pageId: revelioPageId,
    primaryFilterId: filterState.activeKey ?? 'NO_PRIMARY_FILTER',
  });
  const preferencesFromFilters = filtersToPreferences({
    activeFilterMap,
    affectedScope,
  });

  return (
    <UserPreferencesDataProvider
      affectedScope={affectedScope}
      preferencesFromFilters={preferencesFromFilters}
    >
      {({ data, status }) => {
        if (!data || status !== DataProviderQueryStatus.Success) {
          if (status === DataProviderQueryStatus.Error) {
            return <ChartError />;
          }
          return null;
        }

        return (
          <UserPreferencesContext.Provider
            value={{ preferences: data.preferences, status }}
          >
            {children}
          </UserPreferencesContext.Provider>
        );
      }}
    </UserPreferencesDataProvider>
  );
}
